export default {
  /*
  getFirstBreadCrumb (state) {
    if (state.subgroupsBreadcrumbs.length === 0) {
      return [{ 'sl': '', 'en-us': '' }]
    } else {
      return state.subgroupsBreadcrumbs
    }
  },
  */
  getBreadCrumbs (state) {
    return state.subgroupsBreadcrumbs
  },
  getAdminBreadCrumbs (state) {
    return state.adminBreadcrumbs
  },
  pictureBaseURL (state) {
    return state.pictureBaseURL
  },
  googleSignInParams (state) {
    return state.googleSignInParams
  },
  getConcatUserNameSurname (state) {
    if (state.userData === '') return
    return state.userData.firstName + ' ' + state.userData.lastName
  },
  getUser (state) {
    if (state.userData === '') return null
    return state.userData
  },
  getUserId (state) {
    if (state.userData === '') return null
    return state.userData.id
  },
  hasAdminRole (state) {
    if (state.userData !== '') { //  return 0
      return state.userData.implicitRoles.filter((obj) => {
        return obj.name === 'admin'
      }).length
    }
  },
  getLinkToAvatar (state) {
    return state.avatarUrl
  },
  getProfilePictureUrlForDisplay (state, getters) {
    if (state.userData === '') return ''
    if (state.userData.profilePictureUrl === null) {
      return getters.getLinkToAvatar
    } else {
      return state.pictureBaseURL + state.userData.profilePictureUrl
    }
  },
  getSessionKey (state) {
    return state.sessionKey
  },
  getSessionAccessToken (state) {
    return state.sessionAccessToken
  },
  getSessionRefreshToken (state) {
    return state.sessionRefreshToken
  },
  getCurrentLanguage (state) {
    // 86 sl
    // 33 eng
    if (state.userData.lngId === 86) {
      return 'sl'
    } else {
      return 'en-us'
    }
  },
  getAcceptLanguage (state) {
    if (state.userData && state.userData.lngId === 86) {
      return 'sl'
    } else if (state.userData && state.userData.lngId === 33) {
      return 'en-US,en;q=0.9'
    } else {
      return null
    }
  },
  getExerciseLanguage (state, getters) {
    /*
    if (state.exercises.submitExercise.lngs.some(o => o. === state.getters.getCurrentLanguage)) {
      return state.getters.getCurrentLanguage
    } else {
    */
    return 'sl'
    /* OLD CODE
    if (state.exercises.submitExercise.lngs !== undefined) {
      if (state.exercises.submitExercise.lngs.includes(getters.getCurrentLanguage)) {
        return getters.getCurrentLanguage
      } else {
        return state.exercises.submitExercise.lngs[0]
      }
    }
    */
    // }
  },
  isExerciseCorrect (state) {
    return state.exercises.submitExercise.isSolvedCorrectly
  },
  getSubmittedQuestionGuid (state) {
    return state.exercises.submitExercise.questionGUID
  },
  getSubgroups (state) {
    return state.selectedGroup.subgroups
  },
  getDailyChallenges (state) {
    return state.selectedGroup.dailyChallenges
  },
  getExams (state) {
    return state.selectedGroup.exams
  },
  getNameOfSelectedGroup (state) {
    return state.selectedGroup.name
  },
  getNewOrderOfExercises (state) {
    return state.exercisesInOrder.map(exer => exer.id)
  },
  getReports (state) {
    return state.reports
  },
  getSelectedGroupId (state) {
    return state.selectedGroupId
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js